// extracted by mini-css-extract-plugin
module.exports = {"description":"Description_description__c5Ew0","invalid":"Description_invalid__3wCFs"};